import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";
import * as fromActions from "./service-approval-flow.actions";
import * as fromGraphql from "./service-approval-flow.graphql";
import {map, switchMap} from "rxjs/operators";


@Injectable()
export class ServiceApprovalFlowEffects {


  getApprovalStageActions$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getApprovalStageActions),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_APPROVAL_STAGES_ACTIONS,
        fetchPolicy: 'network-only',
        variables: {
          serviceUniqueId: action.serviceUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching services'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0];
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceApprovalFlows({ serviceApprovalFlows: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}





//ng g effect store/entities/service-management/service-approval-flow --root  -m app.module.ts --flat false --skip-tests true
//ng g selector store/entities/service-management/service-approval-flow --flat  false --skip-tests true

//ng g entity store/entities/service-management/service-approval-flow  --reducers ../../reducers/index.ts --flat false --skip-tests true
